import { Alert, AlertTitle, Button, Stack, Typography } from '@mui/material';

type StalledResponseMessageProps = {
  onRetry?: () => void;
};

export const StalledResponseMessage = ({ onRetry }: StalledResponseMessageProps) => (
  <Alert
    severity='warning'
    sx={{
      '& .MuiAlert-message': { width: '100%' },
    }}
  >
    <AlertTitle sx={{ fontWeight: 600 }}>Something went wrong</AlertTitle>
    <Stack spacing={1.5} alignItems='flex-start' sx={{ width: '100%' }}>
      <Typography variant='body2' component='p' color='inherit'>
        Your response couldn't be completed. Try sending your message again.
      </Typography>
      {onRetry && (
        <Button variant='contained' size='small' color='warning' onClick={onRetry}>
          Retry
        </Button>
      )}
    </Stack>
  </Alert>
);
